import { mapGetters, mapActions } from "vuex";
import { POPUP_STYLE } from "../components/TipPopUpIframe";

export default {
  computed: {
    isFavourAward() {
      return this.pageInfo.gift.favour;
    },
    isNormalGift() {
      return this.pageInfo.gift.type === "game";
    },
    isNumberGift() {
      return this.pageInfo.gift.type === "number";
    },
    ...mapGetters(["user", "giftState", "roleInfo", "pageInfo"])
  },
  methods: {
    favourFn() {
      // 如果沒有發獎，就直接提示收藏
      if (!this.isFavourAward) {
        this.doFavour("收藏頁面到瀏覽器，方便下次再玩喔～");
        return;
      }

      // 如果還沒進入遊戲，就提示要先進遊戲
      if (!(this.user.id && this.roleInfo.roleId)) {
        this.doFavour("請先進入遊戲再收藏，確保獎勵發送至您的郵箱哦～");
        return;
      }

      // 如果已經領過了，就提示已領
      if (this.giftState.like_award) {
        this.doFavour("您已獲得過獎勵哦～");
        return;
      }

      this.doFavour();
      this.$store.dispatch("get_save_gift", "like").then(
        data => {
          this.$store.commit("updateGiftState", {
            action: "like",
            value: true
          });
          if (this.isNormalGift) {
            this.doFavour("獎勵已發送至您的郵箱~");
          }
          if (this.isNumberGift) {
            this.$store.commit("updateState", {
              action: "giftNumberGetPopupState",
              value: data.card
            });
            this.$store.commit("updateGiftCard", {
              action: "like",
              value: data.card
            });
          }
          this.gaStatistics({ eventName: "favour_gift" });
        },
        res => {
          this.doFavour("獎勵領取失敗，請稍候再試", POPUP_STYLE.bad, true);
        }
      );
    },
    doFavour(text, style = POPUP_STYLE.good, onlyAlert) {
      if (!onlyAlert) {
        let curTitle =
          window.pageInfo["title"] || window.gameInfo["NAME"] || "";
        try {
          window.external.addFavorite(window.location.href, curTitle);
        } catch (e) {
          try {
            window.sidebar.addPanel(curTitle, window.location.href, "");
          } catch (e) {
            this.$store.commit(
              "updateTipMsg",
              "加入收藏失敗，請使用Ctrl+D進行添加"
            );
          }
        }
      }

      this.$nextTick(() => {
        if (text) {
          this.$store.commit("updateCommonTips", {
            msg: text,
            style: style
          });
        }
      });
    },
    ...mapActions(["gaStatistics"])
  }
};



// WEBPACK FOOTER //
// ./src/mixins/Favour.js